export const AB_TEST_TOKEN = 'EC1D9D34-1BA9-4B0F-BD23-94604A5D52FC';

export enum Experiments {
    CHECKER_ON_MAIN_SEO_EXPERIMENT = '6548c997-64d4-4ba5',
}

export const A_TEST_VALUE = '0';
export const B_TEST_VALUE = '1';
export const C_TEST_VALUE = '2';
